var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35929_46157)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16.5,
    r: 16,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5C16.916 14.5 16 15.416 16 16.5C16 17.584 16.916 18.5 18 18.5C19.084 18.5 20 17.584 20 16.5C20 15.416 19.084 14.5 18 14.5Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3335 11.8333H21.6095L19.8048 10.0287C19.743 9.96665 19.6696 9.91746 19.5887 9.88393C19.5078 9.85041 19.4211 9.83322 19.3335 9.83334H16.6668C16.5793 9.83322 16.4925 9.85041 16.4117 9.88393C16.3308 9.91746 16.2573 9.96665 16.1955 10.0287L14.3908 11.8333H12.6668C11.9315 11.8333 11.3335 12.4313 11.3335 13.1667V20.5C11.3335 21.2353 11.9315 21.8333 12.6668 21.8333H23.3335C24.0688 21.8333 24.6668 21.2353 24.6668 20.5V13.1667C24.6668 12.4313 24.0688 11.8333 23.3335 11.8333ZM18.0002 19.8333C16.1935 19.8333 14.6668 18.3067 14.6668 16.5C14.6668 14.6933 16.1935 13.1667 18.0002 13.1667C19.8068 13.1667 21.3335 14.6933 21.3335 16.5C21.3335 18.3067 19.8068 19.8333 18.0002 19.8333Z",
    fill: "#AEAEAE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35929_46157",
    x: 0,
    y: 0.5,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35929_46157"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35929_46157",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoChange);
export default __webpack_public_path__ + "static/media/photo-change.ee4169cf1719614e44574a90b1b2b059.svg";
export { ForwardRef as ReactComponent };